<!-- 订单价格明细 列表 -->
<template>
  <div class="tabbar tabbar-fixed">
    <slot />
    <price-detail
      ref="priceDetail"
      :price-list="priceList"
    />
  </div>
</template>

<script>
import priceDetail from 'Components/priceDetail'

export default {
  name: 'LdTabbar',
  props: {
    priceList: {
      type: [Array, Object],
      default: function() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  mounted() {},
  created() {},
  methods: {
    toggle() {
      this.$refs.priceDetail.toggle()
    }
  },
  watch: {},
  components: {
    priceDetail
  }
}
</script>

<style lang="less" scoped>
.tabbar {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    width: 100%;
    height: 50px;
}
.tabbar-fixed{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
